import type { TPaginatedResponse } from '@/shared/interfaces/paginacao'
import { HttpService } from '@/shared/lib/http'

export type TGetLeadsRepresadosParams = {
  empreendimentoId?: string
  nome?: string
  telefone?: string
  paginaCorrente?: number
  tamanhoDaPagina?: number
}

export type TLeadRepresado = {
  id: string
  nome: string
  quantidadeDocumentosEnviados: number
  empreendimentos: string[]
}

export class GetLeadsRepresadosService extends HttpService {
  async execute(params: TGetLeadsRepresadosParams): Promise<TPaginatedResponse<TLeadRepresado>> {
    const response = await this.http.get<TPaginatedResponse<TLeadRepresado>>('api/v2/cliente/leadRepresado', {
      params,
    })
    return response.data
  }
}
